// First-touch attribution: where did this browser first arrive from? Sent along at signup so the
// scorecard can count "accounts from Google organic" without depending on GA4.
const KEY = "bb_first_touch";

export function captureFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    localStorage.setItem(KEY, JSON.stringify({
      referrer: document.referrer || "",
      landing_path: window.location.pathname + window.location.search,
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      at: Date.now(),
    }));
  } catch { /* storage unavailable */ }
}

export function getFirstTouch() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}
